/** Player WebRTC 수신 통계 */
export interface PlayerWebRtcStats {
  // ── 핵심 지표 (항상 표시) ──
  rtt: number | null              // ms — candidate-pair.currentRoundTripTime
  bitrate: number | null          // kbps — bytesReceived 차분
  fps: number | null              // inbound-rtp.framesPerSecond
  resolution: string | null       // "1920×1080" 등
  packetLossRate: number | null   // % — packetsLost / total
  jitterBufferDelay: number | null // ms — 평균 jitter buffer 지연
  codec: string | null            // mimeType (예: video/H264)

  // ── 상세 지표 (토글 표시) ──
  jitter: number | null           // ms — inbound-rtp.jitter
  decodeTime: number | null       // ms/frame — 평균 디코딩 시간
  processingDelay: number | null  // ms/frame — 수신~렌더 전체 처리 지연
  framesDropped: number | null    // 차분 count
  nackPerSec: number | null       // NACK 전송 횟수/초
  pliPerSec: number | null        // PLI 전송 횟수/초
  candidateType: string | null    // host / srflx / relay
  protocol: string | null         // udp / tcp
  availableBandwidth: number | null // kbps — 가용 대역폭 추정
  decoderImpl: string | null      // HW/SW 디코더 구현
}

export function createEmptyStats(): PlayerWebRtcStats {
  return {
    rtt: null, bitrate: null, fps: null, resolution: null,
    packetLossRate: null, jitterBufferDelay: null, codec: null,
    jitter: null, decodeTime: null, processingDelay: null,
    framesDropped: null, nackPerSec: null, pliPerSec: null,
    candidateType: null, protocol: null, availableBandwidth: null,
    decoderImpl: null,
  }
}
